import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { LazyLoadScriptService } from './lazy-load-script.service'
import { environment } from 'src/environments/environment';
import { SidebarService } from './sidebar.service';
import * as Sentry from "@sentry/angular";

declare var $: any;

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  sideMenuData: any;
  showMenu : boolean = false;
  showSpinner: boolean = false;;
  isClient:boolean = false;
  MainKeys: any=[];
  sendValue: any;
  sendValueStatus: any = false;
  secrectKey: any;
  proposalUrl: any;
  showBlankMenu: boolean = true;
  eLogBookStatus: any = false;
  dashboardStatus: any = true;
  loggedInUser: any = '';

  constructor(private route: ActivatedRoute,
    private router: Router,
    private sidebarService: SidebarService,
    private lazyLoadService: LazyLoadScriptService) { }

  ngOnInit(): void {
    this.loggedInUser = (window as any).loggedInUser || '';

    // Check Proposal Permission
    if(this.loggedInUser?.preferences?.includes('proposal')){
      this.sendValueStatus = true;
      this.secrectKey = this.loggedInUser.secrectKey;
      this.proposalUrl = environment["proposalUrl"];
    }

    
    this.showSpinner = true;
    this.sidebarService.getSideMenuData().subscribe((response)=>{
      this.isClient = (response.userType == 'c') ? true : false;
      
      if(this.isClient){
        this.sideMenuData = response.data;
      }
      else{
        let res:any = response.data;
        let keys = Object.keys(res);
        this.MainKeys = keys;
        this.sideMenuData = res;
        for(let i=0;i<keys.length;i++) {
          let k =  keys[i];
          this.sideMenuData[k] = res[k]['submenu_data'];
        }
        if (Object.keys(res).length == 1 && Object.keys(res)[0] == "") {
          this.showBlankMenu = false;
        }
      }
      console.log(this.sideMenuData);
      this.showMenu = true;
      this.showSpinner = false;
    });

    $('.sidebar .active').each(function(ele, index) {
      $(this).addClass('active');
      $(this).find('.submenu').addClass('show');
    })

    // Check E-LogBook Permission
    if(this.loggedInUser?.permissions?.includes('/eLogBook')){
      this.eLogBookStatus = true;
    }

    // Check Dashboard Permission
    if(this.loggedInUser?.permissions?.includes('/dashboard')){
      this.dashboardStatus = true;
    }
    
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      const feedback = Sentry.getFeedback();
      const feedbackButton = document.querySelector("#user_feedback");
      if (feedbackButton) {
        feedback.attachTo(feedbackButton, {
          formTitle: "Report a Bug!",
        });
      }
    }, 3000);
  }

  hasDialogStyled: boolean = false;
  
  centerlizeTheFeedBackForm() {
    if(!this.hasDialogStyled){
      setTimeout(() => {
        const sentryFeedback = document.querySelector("#sentry-feedback").shadowRoot;
        const style = document.createElement("style");
        style.textContent = `
          .dialog__position{
            inset: unset !important;
          }
          .dialog{
            background: rgb(0 0 0 / 50%);
          }`;
          
        sentryFeedback.appendChild(style);
        this.hasDialogStyled = true;
      }, 30);
    }
  }

  buildAPP(appname, appurl, approute) {
    this.router.navigate([approute]); //Navigate to particular route
  }

}

import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'removeWhitespace' })
export class removeWhitespacePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    return value.replace(/\s/g, "");
  }
}
